export const OAUTH_SESSION_KEY = "hubrise_oauth_attempt";

export function saveOAuthAttempt(locationId, userId, result) {
  const url = new URL(result.oauth_url);
  const redirect = new URL(url.searchParams.get("redirect_uri"));
  const state = url.searchParams.get("state");
  if (url.origin !== "https://manager.hubrise.com" || url.pathname !== "/oauth2/v1/authorize" || !state) {
    throw new Error("The server returned an invalid HubRise connection URL.");
  }
  if (redirect.origin !== window.location.origin || redirect.pathname !== "/integrations/hubrise/callback" || redirect.search || redirect.hash) {
    throw new Error("The HubRise callback URL must match this website's /integrations/hubrise/callback page. Check the backend configuration.");
  }
  const expiresAt = Date.parse(result.expires_at);
  if (!Number.isFinite(expiresAt) || expiresAt <= Date.now()) {
    throw new Error("The connection attempt has expired. Please try again.");
  }
  sessionStorage.setItem(OAUTH_SESSION_KEY, JSON.stringify({ locationId, userId, state, expiresAt }));
  return url.href;
}

export function consumeOAuthAttempt(params) {
  const raw = sessionStorage.getItem(OAUTH_SESSION_KEY);
  sessionStorage.removeItem(OAUTH_SESSION_KEY);
  let attempt;
  try { attempt = JSON.parse(raw); } catch { /* Handled below. */ }
  if (!attempt || !/^\d+$/.test(String(attempt.locationId)) || !attempt.state || !Number.isFinite(attempt.expiresAt) || attempt.expiresAt <= Date.now()) {
    throw new Error("This connection attempt is missing or expired. Return to Integrations and connect again.");
  }
  const state = params.get("state");
  const error = params.get("error");
  const code = params.get("code");
  // HubRise may omit state on denial, but never accept a code without matching state.
  if ((state && state !== attempt.state) || (!error && !state)) {
    throw new Error("The connection could not be verified. Return to Integrations and connect again.");
  }
  if (Boolean(error) === Boolean(code)) {
    throw new Error("HubRise did not return a valid authorisation response. Please connect again.");
  }
  return { ...attempt, payload: error ? { state: attempt.state, error: "access_denied" } : { state, code } };
}
